// extracted by mini-css-extract-plugin
export default {"nav":"styles__nav___CZS0c"};